export default "/images/1ab155e2c4ad50e13a43f0dcec7e1d9d.avif";